module.exports = __webpack_public_path__ + "static/media/logo-blue.f015083d.png";